import {
  Container,
  Box
} from '@mui/material';

import { useAuth } from '../../components/auth/AuthContext';
import AdminTabs from '../../components/admin/AdminTabs';
import HotelsPage from './hotel/HotelsPage';

interface User {
  id: number;
  username: string;
  email: string;
  userType: 'internal' | 'admin' | 'user';
}

interface AuthResponse {
  jwt: string;
  user: User;
}

export default function AdminPage() {
  const { currentUser } = useAuth();

  // Check if current user has admin access
  const isAuthenticated = currentUser && (currentUser.userType === 'internal' || currentUser.userType === 'admin');

  // Login Form
  if (!isAuthenticated) {
   return <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    Not logged in
      </Box>
  }

  // Admin Dashboard (after authentication)
  return (
    <Box sx={{ minHeight: '100vh', py: 4, mt: 4 }}>
      <Container maxWidth="lg" sx={{ mt: 4 }}>
        
        
        <AdminTabs currentPath="/admin" />
        
        <Box sx={{ mt: 3 }}>
          <HotelsPage />
        </Box>
      </Container>
    </Box>
  );
}